// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gDmE","content":"styles_content__1Y40W","row":"styles_row__3M1ta","footer":"styles_footer__dTIEQ","phraseLength":"styles_phraseLength__3hmzp"};